import React, { useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItemButton from '@mui/material/ListItemButton';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import MoneyOutlinedIcon from '@mui/icons-material/MoneyOutlined';
import ElderlyOutlinedIcon from '@mui/icons-material/ElderlyOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import Person4OutlinedIcon from '@mui/icons-material/Person4Outlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import InsightsIcon from '@mui/icons-material/Insights';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { useDispatch, useSelector } from 'react-redux';
import {  setOpen,updateSideBarActiveTab, updateSidebar } from '../redux/executiveReducer';
import TransLogo from "../assets/KSKB_Logo_TransparentBG.PNG"
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Logout } from "@mui/icons-material";

import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountBalanceSharpIcon from '@mui/icons-material/AccountBalanceSharp';
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import PhotoCameraBackOutlinedIcon from '@mui/icons-material/PhotoCameraBackOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';

import Mui_Tooltip from '../elements/Mui/mui_tooltip';

const drawerWidth = 280;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(6)} )`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)} )`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export default function ExecutiveSideBar() {
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const active_tab = useSelector((state) => state.executive.sideBarActiveTab);
    const sidebar = useSelector((state) => state.executive.sidebar);

    const [openMR, setOpenMr] = React.useState(false);
    const [openAR, setOpenAR] = useState(false);
    const [openES, setOpenES] = useState(false);
    const [openDE, setOpenDE] = useState(false);
    const [openCommunication, setOpenCommunication] = useState(false);
    const open = useSelector((state) => state.executive.open);

    React.useEffect(() => {
        if (location.pathname.startsWith('/communication')) {
            setOpenCommunication(true);
        }
    }, [location.pathname]);

    const pathsWithNavBar = ["/add_member","/executive_summary","/Receipts"];

    const handleDrawerOpen = () => {
        dispatch(setOpen(true));
    };

    const handleDrawerClose = () => {
        dispatch(setOpen(false));
    };

    const handleClick = (listItemName) => {
        if(listItemName === "AR"){
            setOpenAR(!openAR)
            setOpenMr(false)
            // setOpenBD(false)
            setOpenES(false)
            setOpenDE(false)
            setOpenCommunication(false)
            dispatch(updateSideBarActiveTab(''))
        }
        else if (listItemName === "MR"){
            setOpenMr(!openMR)
            setOpenAR(false)
            setOpenES(false)
            setOpenDE(false)
            setOpenCommunication(false)
            dispatch(updateSideBarActiveTab(''))

        }
        // else if(listItemName === "BD"){
        //     setOpenBD(!openBD)
        //     setOpenAR(false)
        //     setOpenES(false)
        //     dispatch(updateSideBarActiveTab(''))
        // }
        else if (listItemName === "DE"){
            setOpenDE(!openDE)
            setOpenAR(false)
            setOpenMr(false)
            setOpenES(false)
            setOpenCommunication(false)
            dispatch(updateSideBarActiveTab(''))
        }
        else if (listItemName === "COM"){
            setOpenCommunication(!openCommunication)
            setOpenAR(false)
            setOpenMr(false)
            setOpenES(false)
            setOpenDE(false)
            dispatch(updateSideBarActiveTab(''))
        }
        else{
            setOpenES(!openES)
            setOpenAR(false)
            setOpenMr(false)
            setOpenDE(false)
            setOpenCommunication(false)
            // setOpenBD(false)
            dispatch(updateSideBarActiveTab(''))
        }
    };
   
    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/login');
    }; 

    const handleTabChange = (tab, section) => {
        dispatch(updateSidebar(false));
        if(!section){
            setOpenES(false)
            setOpenAR(false)
            setOpenMr(false)
            setOpenDE(false)
            setOpenCommunication(false)
        }
        switch (tab) {
            case 'CO':
                navigate('/executive_summary')
                dispatch(updateSideBarActiveTab('CO'))
                break;
            case 'RI':
                navigate('/executive_summary')
                dispatch(updateSideBarActiveTab('RI'))
                break;

            case 'NMC':
                navigate('/executive_summary')
                dispatch(updateSideBarActiveTab('NMC'))
                break;

            case 'WD':
                navigate('/executive_summary')  
                dispatch(updateSideBarActiveTab('WD'))
            
                break;
            case 'AM':
                navigate('/executive_summary') 
                dispatch(updateSideBarActiveTab('AM'))
                
                break;
            case 'MRE':
                navigate('/estate') 
                dispatch(updateSideBarActiveTab('MRE'))
                
                break;
            case 'MRB':
                navigate('/bankname') 
                dispatch(updateSideBarActiveTab('MRB'))
                
                break;
            case 'MRCB':
                navigate('/coopbank') 
                dispatch(updateSideBarActiveTab('MRCB'))
                
                break;
            case 'MROcc':
                navigate('/occupation') 
                dispatch(updateSideBarActiveTab('MROcc'))
                
                break;
            case 'MRBPU':
                navigate('/bulk-photo-upload')
                dispatch(updateSideBarActiveTab('MRBPU'))
                
                break;
            case 'AE':
                
                dispatch(updateSideBarActiveTab('AE'))
                
                break;
            case 'GDS':
                
                dispatch(updateSideBarActiveTab('GDS'))
                
                break;
            case 'NS':
                navigate('/executive_summary')
                dispatch(updateSideBarActiveTab('NS'))
                
                break;
            case 'DI':
                
                dispatch(updateSideBarActiveTab('DI'))
                
                break;
            case 'NC':
                
                dispatch(updateSideBarActiveTab('NC'))
                
                break;
            case 'ARP':
                navigate('/payments')
                dispatch(updateSideBarActiveTab('ARP'))
                
                break;
            case 'ARL':
                navigate('/loan')
                dispatch(updateSideBarActiveTab('ARL'))
                
                break;
            case 'ARSD':
                navigate('/specificDeposit')
                dispatch(updateSideBarActiveTab('ARSD'))
                
                break;
            case 'ARR':
                navigate('/Receipts')
                dispatch(updateSideBarActiveTab('ARR'))
                
                break;
            case 'ARD':
                navigate('/dividend')
                dispatch(updateSideBarActiveTab('ARD'))
                
                break;
            case 'ARDE':
                navigate('/deduction')
                dispatch(updateSideBarActiveTab('ARDE'))
                
                break;
            case 'ARCDE':
                navigate('/custom-deduction')
                dispatch(updateSideBarActiveTab('ARCDE'))
                
                break;
            case 'AIR':
                navigate('/chat')
                dispatch(updateSideBarActiveTab('AIR'))
                    
                break;
            case 'COM_E':
                navigate('/communication/email')
                dispatch(updateSideBarActiveTab('COM_E'))
                break;
            case 'COM_W':
                navigate('/communication/whatsapp')
                dispatch(updateSideBarActiveTab('COM_W'))
                break;
            case 'COM_WTC':
                navigate('/communication/whatsapp/trigger-configuration')
                dispatch(updateSideBarActiveTab('COM_WTC'))
                break;
            case 'MD':
                navigate('/add_member')
                dispatch(updateSideBarActiveTab('MD'))
                break;
            case 'SC':
                navigate('/share_certificate')
                dispatch(updateSideBarActiveTab('SC'))
                break;
            // case 'AS':
            //     navigate("/account-statement")
            //     dispatch(updateSideBarActiveTab('AS'))
            //     break;
            case 'BAS':
                navigate("/account-statement")
                dispatch(updateSideBarActiveTab('BAS'))
                break;
            default:
                break;
        }
    };

  return (
    <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" open={open} sx={{ background: 'var(--pallate-green-500, #E7EFE9)'}}>
            <Toolbar sx={{minHeight: '40px !important'}}>
                <IconButton
                    color="black"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={{
                    marginRight: 5,
                    ...(open && { display: 'none' }),
                    }}
                >
                    <MenuIcon />
                </IconButton>
            
                <Box sx={{ background: 'var(--pallate-green-500, #E7EFE9)',width:"100%", padding: "2px 2px", display: "flex", alignItems: "center", justifyContent: "space-between",position:"sticky",top:0,zIndex:2 }}>
        
                    <Box sx={{display:"flex",gap:"24px",alignItems:"center"}}>
                        {/* <IconButton onClick={()=>dispatch(updateSidebar(true))}><MenuIcon sx={{color:"#FFF"}}/></IconButton> */}
                        <Box component="img" sx={{width:"32px", height:"32px"}} src={TransLogo}></Box>
                        <Typography sx={{ fontSize: "14px", fontWeight: 600, lineHeight: "28px", color: "black" }}>KOPERASI SERBAGUNA KEBANGSAAN BERHAD (4391)</Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center",justifyContent:"space-between", gap: "16px" }}>
                        {/* {!pathsWithNavBar.includes(location.pathname) &&<> 
                            <Button component={Link} to="/account-statement" variant="filled" sx={{ background: "#fff", borderColor: "##fff", color: "#288d2c", "&:hover": { borderColor: "#fff", background: "#fff" }, fontSize: "16px", fontWeight: "400", lineHeight: "24px", padding: "12px", textTransform: "none", }} startIcon={<AccountBalanceIcon />} >Account Statement</Button>
                            </>} */}

                        <Tooltip title="Logout" arrow>
                            <Button
                                sx={{ color: "black" }}
                                onClick={handleLogout}
                            >
                                <Logout />
                            </Button>
                        </Tooltip>
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
            <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
                {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
            </DrawerHeader>
            <Divider />
            <List>
                
                {/* ------------ MEMBER DETAILS START------------  */}
                <Mui_Tooltip open={open} title="Member Details">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: active_tab=="MD" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="MD" ? '#288d2c' : '#288d2c',color: active_tab=="MD" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="MD" ? '#FFFFFF' : '#64748B', fontWeight:active_tab=="MD"?600:400}} onClick={() => handleTabChange("MD")}>
                    <Box>
                    <GroupsOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="MD"?600:400}}/>
                    </Box>
                    <ListItemText primary="Member Details" sx={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:active_tab=="MD"?600:400}} />
                </ListItemButton>
                </Mui_Tooltip>   
                {/* ------------ MEMBER DETAILS END------------  */}

                {/* ------------ PAYMENTS SECTION START------------  */}
                <Mui_Tooltip open={open} title="Payments">
                    <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: active_tab=="ARP" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="ARP" ? '#288d2c' : '#288d2c',color: active_tab=="ARP" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="ARP" ? '#FFFFFF' : '#64748B', fontWeight:active_tab=="ARP"?600:400}} onClick={() => { handleTabChange('ARP') }}>
                        <Box>
                            <PaymentsOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="ARP"?600:400}} />
                        </Box>
                        <ListItemText primary="Payments" sx={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:active_tab=="ARP"?600:400}}/>
                    </ListItemButton>
                </Mui_Tooltip> 
                {/* ------------ PAYMENTS SECTION END------------  */}

                {/* ---------- RECEIPTS SECTION START ------------ */}
                <Mui_Tooltip open={open} title="Receipts">
                    <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: active_tab=="ARR" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="ARR" ? '#288d2c' : '#288d2c',color: active_tab=="ARR" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="ARR" ? '#FFFFFF' : '#64748B', fontWeight:active_tab=="ARR"?600:400}} onClick={() => { handleTabChange('ARR') }}>
                        <Box>
                            <ReceiptOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="ARR"?600:400}} />
                        </Box>
                        <ListItemText primary="Receipts" sx={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:active_tab=="ARR"?600:400}}/>
                    </ListItemButton>
                </Mui_Tooltip>
                {/* ------------ RECEIPTS SECTION END ------------ */}

                {/* ------------ SPECIFIC DEPOSIT SECTION START------------  */}
                <Mui_Tooltip open={open} title="Specific Deposit">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: active_tab=="ARSD" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="ARSD" ? '#288d2c' : '#288d2c',color: active_tab=="ARSD" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="ARSD" ? '#FFFFFF' : '#64748B', fontWeight:active_tab=="ARSD"?600:400}}onClick={()=>{handleTabChange('ARSD')}}>
                    <Box>
                    <SavingsOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="ARSD"?600:400}}/>
                    </Box>
                    <ListItemText primary="Specific Deposit" sx={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:active_tab=="ARSD"?600:400}}/>
                </ListItemButton>
                </Mui_Tooltip>            
                {/* ------------ SEPECIFIC DEPOSIT SECTION END------------  */}

                {/* ------------ LOAN SECTION START------------  */}
                <Mui_Tooltip open={open} title="Loan">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: active_tab=="ARL" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="ARL" ? '#288d2c' : '#288d2c',color: active_tab=="ARL" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="ARL" ? '#FFFFFF' : '#64748B', fontWeight:active_tab=="ARL"?600:400}} onClick={()=>{handleTabChange('ARL')}}>
                    <Box>
                    <ReceiptLongOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="ARL"?600:400}}/>
                    </Box>
                    <ListItemText primary="Loan" sx={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:active_tab=="ARL"?600:400}}/>
                </ListItemButton>
                </Mui_Tooltip> 
                {/* ------------ LOAN SECTION END------------  */}

                {/* ------------ EXECUTIVE DETAILS SECTION START------------  */}
                <Mui_Tooltip open={open} title="Executive Details">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: openES ? '#288d2c' : 'transparent','&:hover': { background: openES ? '#288d2c' : '#288d2c',color: openES ? '#FFFFFF' : '#FFFFFF'},color: openES ? '#FFFFFF' : '#64748B',fontWeight:openES==true?600:400}} onClick={() => handleClick("ES")}>
                    <Box>
                    <SummarizeOutlinedIcon sx={{fontSize:"24px",fontWeight:openES==true?600:400}}/>
                    </Box>
                    <ListItemText primary="Executive Details" style={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:openES==true?600:400}}  />
                    {openES ? <ExpandMore /> : <ExpandMore style={{ transform: "rotate(-90deg)"}}/>}
                </ListItemButton>
                </Mui_Tooltip> 
                <Collapse in={openES} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                         <Mui_Tooltip open={open} title="Cut-off Date">
                        <ListItemButton style={active_tab=="CO"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('CO', true)}}>
                            <Box>
                            <DateRangeOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="CO"?600:400 ,color:active_tab=="CO"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="CO"?700:400,lineHeight:"28px",color:active_tab=="CO"?"#101010":"#288d2c"}}>Cut-off date</Typography>
                        </ListItemButton>
                        </Mui_Tooltip> 

                        <Mui_Tooltip open={open} title="Receipt Issued">
                        <ListItemButton style={active_tab=="RI"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('RI', true)}}>
                            <Box>
                            <ReceiptLongOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="RI"?600:400 ,color:active_tab=="RI"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="RI"?700:400,lineHeight:"28px",color:active_tab=="RI"?"#101010":"#288d2c"}}>Receipt Issued</Typography>
                        </ListItemButton>
                        </Mui_Tooltip> 

                        <Mui_Tooltip open={open} title="New Member Report">
                        <ListItemButton style={active_tab=="NMC"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('NMC', true)}}>
                            <Box>
                            <PersonAddAltOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="NMC"?600:400 ,color:active_tab=="NMC"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="NMC"?700:400,lineHeight:"28px",color:active_tab=="NMC"?"#101010":"#288d2c"}}>New Member Report</Typography>
                        </ListItemButton>
                        </Mui_Tooltip> 

                        <Mui_Tooltip open={open} title="Withdrawal">
                        <ListItemButton style={active_tab=="WD"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('WD', true)}}>
                            <Box>
                                <MoneyOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="WD"?600:400 ,color:active_tab=="WD"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="WD"?700:400,lineHeight:"28px",color:active_tab=="WD"?"#101010":"#288d2c"}}>Withdrawal</Typography>
                        </ListItemButton>
                        </Mui_Tooltip> 

                        <Mui_Tooltip open={open} title="Ageing Member">
                        <ListItemButton style={active_tab=="AM"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('AM', true)}}>
                            <Box>
                                <ElderlyOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="AM"?600:400 ,color:active_tab=="AM"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="AM"?700:400,lineHeight:"28px",color:active_tab=="AM"?"#101010":"#288d2c"}}>Ageing Member</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>

                        <Mui_Tooltip open={open} title="Ageing Estate">
                        <ListItemButton style={active_tab=="AE"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('AE', true)}} disabled={true}>
                            <Box>
                                <Person4OutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="AE"?600:400 ,color:active_tab=="AE"?"#288d2c":"#288d2c"}} />
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="AE"?700:400,lineHeight:"28px",color:active_tab=="AE"?"#101010":"#288d2c"}}>Ageing Estate</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>

                        <Mui_Tooltip open={open} title="Nominee Status">
                        <ListItemButton style={active_tab=="NS"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('NS', true)}}>
                            <Box>
                                <PeopleOutlineOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="NS"?600:400 ,color:active_tab=="NS"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="NS"?700:400,lineHeight:"28px",color:active_tab=="NS"?"#101010":"#288d2c"}}>Nominee Status</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>
                    </List>
                </Collapse>
                {/* ------------ EXECUTIVE DETAILS END------------  */}

                {/* ------------ DIVIDEND SECTION START------------  */}
                <Mui_Tooltip open={open} title="Dividend">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: active_tab=="ARD" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="ARD" ? '#288d2c' : '#288d2c',color: active_tab=="ARD" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="ARD" ? '#FFFFFF' : '#64748B', fontWeight:active_tab=="ARD"?600:400}} onClick={()=>{handleTabChange('ARD')}}>
                    <Box>
                        <StoreOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="ARD"?600:400}}/>
                    </Box>
                    <ListItemText primary="Dividend" sx={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:active_tab=="ARD"?600:400}}/>
                </ListItemButton>
                </Mui_Tooltip> 
                {/* ------------ DIVIDEND SECTION END------------  */}

                {/* ------------  DEDUCTION SECTION START------------  */}
                <Mui_Tooltip open={open} title="Deduction">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: openDE ? '#288d2c' : 'transparent','&:hover': { background: openDE ? '#288d2c' : '#288d2c',color: openDE ? '#FFFFFF' : '#FFFFFF'},color: openDE ? '#FFFFFF' : '#64748B',fontWeight:openDE==true?600:400}} onClick={() => handleClick("DE")}>
                    <Box>
                        <PriceChangeOutlinedIcon sx={{fontSize:"24px",fontWeight:openDE==true?600:400}}/>
                    </Box>
                    <ListItemText primary="Deduction" style={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:openDE==true?600:400}}  />
                    {openDE ? <ExpandMore /> : <ExpandMore style={{ transform: "rotate(-90deg)"}}/>}
                </ListItemButton>
                </Mui_Tooltip> 
                <Collapse in={openDE} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <Mui_Tooltip open={open} title="Deduction">
                        <ListItemButton style={active_tab=="ARDE"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('ARDE', true)}}>
                            <Box>
                            <PriceChangeOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="ARDE"?600:400 ,color:active_tab=="ARDE"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="ARDE"?700:400,lineHeight:"28px",color:active_tab=="ARDE"?"#101010":"#288d2c"}}>Deduction</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>

                        <Mui_Tooltip open={open} title="Custom Deduction">
                        <ListItemButton style={active_tab=="ARCDE"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('ARCDE', true)}}>
                            <Box>
                            <PriceChangeOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="ARCDE"?600:400 ,color:active_tab=="ARCDE"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="ARCDE"?700:400,lineHeight:"28px",color:active_tab=="ARCDE"?"#101010":"#288d2c"}}>Custom Deduction</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>
                    </List>
                </Collapse>
                {/* ------------ DEDUCTION SECTION END------------  */}

                {/* ------------ SHARE CERTIFICATE SECTION START */}
                <Mui_Tooltip open={open} title="Share Certificate">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: active_tab=="SC" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="SC" ? '#288d2c' : '#288d2c',color: active_tab=="SC" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="SC" ? '#FFFFFF' : '#64748B',fontWeight:active_tab=="SC"?600:400}} onClick={() => handleTabChange("SC")}>
                    <Box>
                    <ArticleIcon sx={{fontSize:"24px",fontWeight:active_tab=="SC"?600:400}}/>
                    </Box>
                    <ListItemText primary="Share Certificate" style={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:active_tab=="SC"?600:400}} />
                </ListItemButton>
                </Mui_Tooltip>
                {/* ------------ SHARE CERT SECTION END------------  */}

                {/* ------------ ACCOUNT STATEMENT SECTION START------------  */}
                <Mui_Tooltip open={open} title="Account Statement">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: active_tab=="BAS" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="BAS" ? '#288d2c' : '#288d2c',color: active_tab=="BAS" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="BAS" ? '#FFFFFF' : '#64748B',fontWeight:active_tab=="BAS"?600:400}} onClick={() => handleTabChange("BAS")}>
                    <Box>
                    <AccountBalanceIcon sx={{fontSize:"24px",fontWeight:active_tab=="BAS"?600:400}}/>
                    </Box>
                    <ListItemText primary="Account Statement" style={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:active_tab=="BAS"?600:400}} />
                </ListItemButton>
                </Mui_Tooltip>
                {/* ------------ ACCOUNT STATEMENT SECTION END------------  */}

                {/* ------------ MASTER RECORD SECTION START------------ */}
                <Mui_Tooltip open={open} title="Master Records">
                    <ListItemButton
                        onClick={() => handleClick("MR")}
                        sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        width: '100%',
                        background: openMR ? '#288d2c' : 'transparent',
                        '&:hover': {
                            background: openMR ? '#288d2c' : '#288d2c',
                            color: openMR ? '#FFFFFF' : '#FFFFFF'
                        },
                        color: openMR ? '#FFFFFF' : '#64748B',
                        fontWeight: openMR ? 600 : 400,
                        fontSize:'32px',
                        fontFamily:"inter",
                        }}
                    >
                        <AutoStoriesOutlinedIcon sx={{ fontSize: '24px', fontWeight: openMR ? 600 : 400 }} />
                        <ListItemText primary="Master Records" sx={{ fontFamily: 'inter', fontSize: '16px', lineHeight: '28px', fontWeight: openMR ? 600 : 400 }} />
                        {openMR ? <ExpandMore /> : <ExpandMore sx={{ transform: 'rotate(-90deg)' }} />}
                    </ListItemButton>
                </Mui_Tooltip>                
                <Collapse in={openMR} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                    <Mui_Tooltip open={open} title="Estate">
                        <ListItemButton style={active_tab=="MRE"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"red"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('MRE', true)}}>
                            <Box>
                            <LocationCityOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="MRE"?600:400 ,color:active_tab=="MRE"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="MRE"?700:400,lineHeight:"28px",color:active_tab=="MRE"?"#101010":"#288d2c"}}>Estate</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>

                        <Mui_Tooltip open={open} title="Bank Names">
                        <ListItemButton style={active_tab=="MRB"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('MRB', true)}}>
                            <Box>
                            <AccountBalanceOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="MRB"?600:400 ,color:active_tab=="MRB"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="MRB"?700:400,lineHeight:"28px",color:active_tab=="MRB"?"#101010":"#288d2c"}}>Bank Names</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>

                        <Mui_Tooltip open={open} title="Co-Op Bank Name">
                        <ListItemButton style={active_tab=="MRCB"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('MRCB', true)}}>
                            <Box>
                            <AccountBalanceSharpIcon sx={{fontSize:"24px",fontWeight:active_tab=="MRCB"?600:400 ,color:active_tab=="MRCB"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="MRCB"?700:400,lineHeight:"28px",color:active_tab=="ARSD"?"#101010":"#288d2c"}}>Co-Op Bank Name</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>

                        <Mui_Tooltip open={open} title="Occupation">
                        <ListItemButton style={active_tab=="MROcc"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('MROcc', true)}}>
                            <Box>
                            <WorkSharpIcon sx={{fontSize:"24px",fontWeight:active_tab=="MROcc"?600:400 ,color:active_tab=="MROcc"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="MROcc"?700:400,lineHeight:"28px",color:active_tab=="ARSD"?"#101010":"#288d2c"}}>Occupation</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>
                        <Mui_Tooltip open={open} title="Bulk Photo Upload">
                        <ListItemButton style={active_tab=="MRBPU"?{background:"#E2E8F0",display:"flex",gap:"16px"} :{cursor:"pointer","&:hover":{background:"#E2E8F0"},display:"flex",gap:"16px"}} onClick={()=>{handleTabChange('MRBPU', true)}}>
                            <Box>
                            <PhotoCameraBackOutlinedIcon sx={{fontSize:"24px",fontWeight:active_tab=="MRBPU"?600:400 ,color:active_tab=="MRBPU"?"#288d2c":"#288d2c"}}/>
                            </Box>
                            <Typography sx={{fontFamily:"inter",fontSize:"16px",fontWeight:active_tab=="MRBPU"?700:400,lineHeight:"28px",color:active_tab=="MRBPU"?"#101010":"#288d2c"}}>Bulk Photo Upload</Typography>
                        </ListItemButton>
                        </Mui_Tooltip>
                    </List>
                </Collapse>
                {/* ------------ MASTER RECORD SECTION END ------------ */}

                {/* ------------ AI REPORTS SECTION START------------  */}
                <Mui_Tooltip open={open} title="AI Reports">
                <ListItemButton style={{display: "flex",alignItems:"center",gap:"16px",width:"280px",background: active_tab=="AIR" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="AIR" ? '#288d2c' : '#288d2c',color: active_tab=="AIR" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="AIR" ? '#FFFFFF' : '#64748B',fontWeight:active_tab=="AIR"?600:400}} onClick={()=>{handleTabChange('AIR')}}>
                    <Box>
                    <InsightsIcon sx={{fontSize:"24px",color:active_tab=="AIR"?"#FFFFFF":"#64748B",fontWeight:active_tab=="AIR"?600:400}}/>
                    </Box>
                    <ListItemText primary="AI Reports" style={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",color:active_tab=="AIR"?"#FFFFFF":"#64748B",fontWeight:active_tab=="AIR"?600:400}}/>
                </ListItemButton>
                </Mui_Tooltip>
                {/* ------------ AI REPORTS SECTION END------------  */}

                {/* ------------ COMMUNICATION SECTION START------------  */}
                <Mui_Tooltip open={open} title="Communication">
                    <ListItemButton
                        onClick={() => handleClick('COM')}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            width: '100%',
                            background: openCommunication ? '#288d2c' : 'transparent',
                            '&:hover': { background: openCommunication ? '#288d2c' : '#288d2c', color: openCommunication ? '#FFFFFF' : '#FFFFFF' },
                            color: openCommunication ? '#FFFFFF' : '#64748B',
                            fontWeight: openCommunication ? 600 : 400,
                            fontFamily: 'inter',
                        }}
                    >
                        <ForumOutlinedIcon sx={{ fontSize: '24px', fontWeight: openCommunication ? 600 : 400 }} />
                        <ListItemText primary="Communication" sx={{ fontFamily: 'inter', fontSize: '16px', lineHeight: '28px', fontWeight: openCommunication ? 600 : 400 }} />
                        {openCommunication ? <ExpandMore /> : <ExpandMore sx={{ transform: 'rotate(-90deg)' }} />}
                    </ListItemButton>
                </Mui_Tooltip>
                <Collapse in={openCommunication} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <Mui_Tooltip open={open} title="Email communication">
                            <ListItemButton
                                style={
                                    active_tab === 'COM_E' || ['/communication/email', '/communication/compose'].includes(location.pathname)
                                        ? { background: '#E2E8F0', display: 'flex', gap: '16px'}
                                        : { cursor: 'pointer', display: 'flex', gap: '16px' }
                                }
                                onClick={() => handleTabChange('COM_E', true)}
                            >
                                <EmailOutlinedIcon sx={{ fontSize: '24px', color: '#288d2c' }} />
                                <Typography sx={{ fontFamily: 'inter', fontSize: '16px', fontWeight: active_tab === 'COM_E' || ['/communication/email', '/communication/compose'].includes(location.pathname) ? 700 : 400, lineHeight: '28px', color: '#288d2c' }}>
                                    Email
                                </Typography>
                            </ListItemButton>
                        </Mui_Tooltip>
                        <Mui_Tooltip open={open} title="WhatsApp communication">
                            <ListItemButton
                                style={
                                    active_tab === 'COM_W' || ['/communication/whatsapp', '/communication/whatsapp/bulk', '/communication/whatsapp/templates', '/communication/whatsapp-compose'].includes(location.pathname)
                                        ? { background: '#E2E8F0', display: 'flex', gap: '16px' }
                                        : { cursor: 'pointer', display: 'flex', gap: '16px' }
                                }
                                onClick={() => handleTabChange('COM_W', true)}
                            >
                                <WhatsAppIcon sx={{ fontSize: '24px', color: '#288d2c' }} />
                                <Typography sx={{ fontFamily: 'inter', fontSize: '16px', fontWeight: active_tab === 'COM_W' || ['/communication/whatsapp', '/communication/whatsapp/bulk', '/communication/whatsapp/templates', '/communication/whatsapp-compose'].includes(location.pathname) ? 700 : 400, lineHeight: '28px', color: '#288d2c' }}>
                                    WhatsApp
                                </Typography>
                            </ListItemButton>
                        </Mui_Tooltip>
                        <Mui_Tooltip open={open} title="Azure timer trigger & backend path">
                            <ListItemButton
                                style={
                                    active_tab === 'COM_WTC' || location.pathname === '/communication/whatsapp/trigger-configuration'
                                        ? { background: '#E2E8F0', display: 'flex', gap: '16px'}
                                        : { cursor: 'pointer', display: 'flex', gap: '16px' }
                                }
                                onClick={() => handleTabChange('COM_WTC', true)}
                            >
                                <ScheduleOutlinedIcon sx={{ fontSize: '24px', color: '#288d2c' }} />
                                <Typography sx={{ fontFamily: 'inter', fontSize: '16px', fontWeight: active_tab === 'COM_WTC' || location.pathname === '/communication/whatsapp/trigger-configuration' ? 700 : 400, lineHeight: '28px', color: '#288d2c' }}>
                                    Trigger configuration
                                </Typography>
                            </ListItemButton>
                        </Mui_Tooltip>
                    </List>
                </Collapse>
                {/* ------------ COMMUNICATION SECTION END------------  */}
                
                {/* <Mui_Tooltip open={open} title="Actions and Receipts">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",padding:"16px",width:"100%",background: openAR ? '#288d2c' : 'transparent','&:hover': { background: openAR ? '#288d2c' : '#288d2c',color: openAR ? '#FFFFFF' : '#FFFFFF'},color: openAR ? '#FFFFFF' : '#64748B',fontWeight:openAR==true?600:400}} onClick={() => handleClick("AR")}>
                    <Box>
                    <MonetizationOnOutlinedIcon sx={{fontSize:"24px",fontWeight:openAR==true?600:400}}/>
                    </Box>
                    <ListItemText primary="Actions & Receipts" sx={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:openAR==true?600:400}} />
                    {openAR==true ? <ExpandMore /> : <ExpandMore sx={{ transform: "rotate(-90deg)"}}/>}
                </ListItemButton>
                </Mui_Tooltip>  */}

                {/* <Mui_Tooltip open={open} title="Account Statement">
                <ListItemButton sx={{display: "flex",alignItems:"center",gap:"16px",width:"100%",background: active_tab=="AS" ? '#288d2c' : 'transparent','&:hover': { background: active_tab=="AS" ? '#288d2c' : '#288d2c',color: active_tab=="AS" ? '#FFFFFF' : '#FFFFFF'},color: active_tab=="AS" ? '#FFFFFF' : '#64748B',fontWeight:active_tab=="AS"?600:400}} onClick={() => handleTabChange("AS")}>
                    <Box>
                    <AccountBalanceIcon sx={{fontSize:"24px",fontWeight:active_tab=="AS"?600:400}}/>
                    </Box>
                    <ListItemText primary="Account Statement" style={{fontFamily:"inter",fontSize:"16px",lineHeight:"28px",fontWeight:active_tab=="AS"?600:400}} />
                </ListItemButton>
                </Mui_Tooltip> */}

            </List>
        </Drawer>
    </Box>
  );
}